module.exports = __webpack_public_path__ + "static/media/paint-brush-alt.766c8c27.svg";